import React from 'react'

export default function Hero() {
  return (
    <div className='md:p-0 p-2'>
      <div className='header md:mt-5 relative'>
        <div className='md:absolute static flex md:gap-2 gap-2 md:flex-col flex-row items-center justify-end md:top-[20vw] top-[15vw] md:right-10 '>
          <a href="" className='block'>
            <img src="/images/t.png" alt="" className='md:w-[5vw] w-[12vw] animate__fadeInUp wow animate__animated ' />
          </a>
          <a href="" className='block'>
            <img src="/images/x.png" alt="" className='md:w-[5vw] w-[12vw] animate__fadeInUp wow animate__animated' />
          </a>
          <a href="" className='md:hidden block'>
            <img src="/images/telegram.png" alt="" className='w-[40vw] animate__fadeInUp wow animate__animated' />
          </a>
        </div>
        <a href="" className='absolute md:-top-9 -top-2 md:right-7 right-5 md:block hidden'>
          <img src="/images/telegram.png" alt="" className='w-[17vw]' />
        </a>
        <div className='md:hidden flex flex-col items-center text-center gap-4 absolute px-5 top-[50vw] '>
          <h1 className='uppercase text-[18vw] italic text-[#C8D0D8] font-extrabold leading-tight animate__fadeInLeft animate__animated wow'>chinu
            inu  </h1>
          <p className='text-3xl font-semibold animate__fadeInRight animate__animated wow  animate__delay-1s'>Supercharge Your <br /> Twitter Presence <br /> with Chinu AI</p>
          <p className='text-xl text-gray-300 animate__fadeInLeft animate__animated wow  animate__delay-2s'>Meet your on-brand AI ally— <br /> crafting tweets, generating <br /> visuals, & engaging your <br /> audience in real time.</p>

        </div>
        <img src="/images/header.gif" alt="" className='md:block hidden' />
        <img src="/images/mobile.png" alt="" className='md:hidden block' />


      </div>
    </div>
  )

}
